export enum SearchState {
  BASE_START = 'BASE_START',
  BASE_FOCUSED_EMPTY = 'BASE_FOCUSED_EMPTY',
  BASE_WITH_TEXT = 'BASE_WITH_TEXT',
  SEARCH_FOCUSED_EMPTY = 'SEARCH_FOCUSED_EMPTY',
  SEARCH_WITH_TEXT = 'SEARCH_WITH_TEXT',
  SEARCH_REQUESTED = 'SEARCH_REQUESTED',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
}
